import React from 'react'
import { useTranslation } from 'react-i18next'
import { ModelTypes } from '@/types'
import { Pagination, PaginationProps } from '../Pagination'

interface IProps extends Omit<PaginationProps, 'total' | 'page'> {
  page?: number | null
  meta?: ModelTypes.PaginationResponseMeta
  onChange: (page: number) => void
}

export const MetaPagination = ({
  page = 1,
  meta,
  onChange,
  position = 'right',
  ...props
}: IProps) => {
  const { t } = useTranslation()

  if (!meta) {
    return null
  }

  const { total_pages, current_page } = meta

  const total = meta ? meta.total_pages : 0

  const visible = total_pages > 1 || current_page > total_pages

  return (
    <>
      {visible && page && (
        <Pagination {...props} position={position} value={page} total={total} onChange={onChange} />
      )}
    </>
  )
}
